import React from "react";
import PolymatchResults from "./PolymatchResults";

const PolymatchResults_Islamic = () => {
  // This component will use the general PolymatchResults component
  // but can be customized later for Islamic-specific results
  return <PolymatchResults competition="islamic" />;
};

export default PolymatchResults_Islamic;
